// assets/build-my-routine.js — Mirai Build My Routine wizard
(function () {
  'use strict';

  var STORAGE_KEY = 'mirai-routine-draft';
  var API_RECOMMEND = '/apps/subscriptions/routine/recommend';
  var API_SAVE = '/apps/subscriptions/routine/save';
  var API_SHOP_ANON = '/apps/subscriptions/routine/shop-anonymous';

  var INPUTS = [
    {
      key: 'skin_type',
      question: "What's your skin type?",
      options: [
        { value: 'oily',        label: 'Oily / Acne-Prone' },
        { value: 'combination', label: 'Combination' },
        { value: 'dry',         label: 'Dry' },
        { value: 'sensitive',   label: 'Sensitive / Reactive' },
        { value: 'normal',      label: 'Normal' },
        { value: 'mature',      label: 'Mature (40+)' },
      ],
    },
    {
      key: 'concern',
      question: "What's your main concern?",
      options: [
        { value: 'acne',         label: 'Acne & Breakouts' },
        { value: 'dark_spots',   label: 'Dark Spots & Hyperpigmentation' },
        { value: 'aging',        label: 'Fine Lines & Aging' },
        { value: 'redness',      label: 'Redness & Sensitivity' },
        { value: 'dehydration',  label: 'Dryness & Dehydration' },
        { value: 'texture',      label: 'Dullness & Uneven Texture' },
        { value: 'pores',        label: 'Visible Pores' },
      ],
    },
    {
      key: 'budget',
      question: 'Your budget for the full routine?',
      options: [
        { value: 'starter',  label: 'Starter',       sub: '$50-100' },
        { value: 'standard', label: 'Standard',      sub: '$100-200' },
        { value: 'premium',  label: "Editor's Best", sub: '$200+' },
      ],
    },
    {
      key: 'depth',
      question: 'How deep do you want to go?',
      options: [
        { value: 'essentials', label: 'Essentials',           sub: 'Cleanser, toner, moisturizer, SPF (4 products)' },
        { value: 'daily_glow', label: 'Daily Glow',           sub: '+ essence, serum, eye cream (7 products)' },
        { value: 'full_amspm', label: 'Full K-Beauty AM + PM', sub: '10 products, split routine' },
      ],
    },
  ];

  var STEP_LABELS = {
    cleanser: 'Cleanser', toner: 'Toner', essence: 'Essence', serum: 'Serum',
    eye_cream: 'Eye Cream', moisturizer: 'Moisturizer', sunscreen: 'Sunscreen',
    am_cleanser: 'AM Cleanser', am_toner: 'AM Toner', am_serum: 'AM Serum',
    am_eye: 'AM Eye Cream', am_moisturizer: 'AM Moisturizer', am_sunscreen: 'AM Sunscreen',
    pm_oil_cleanser: 'PM Oil Cleanser', pm_water_cleanser: 'PM Water Cleanser',
    pm_treatment: 'PM Treatment', pm_eye: 'PM Eye Cream', pm_moisturizer: 'PM Moisturizer',
  };

  var root = document.getElementById('mirai-routine-wizard');
  if (!root) return;
  var customerLoggedIn = root.dataset.customerLoggedIn === 'true';
  var saveAfterLogin = root.dataset.saveAfterLogin === '1';

  var state = loadState() || {
    inputs: { skin_type: null, concern: null, budget: null, depth: null },
    inputIdx: 0,
    recommendations: null,
    stepKeys: null,
    stepIdx: 0,
    selected: {},
  };

  function loadState() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; } }
  function saveState() { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
  function clearState() { localStorage.removeItem(STORAGE_KEY); }

  function show(screenName, attrs) {
    var screens = root.querySelectorAll('[data-screen]');
    for (var i = 0; i < screens.length; i++) {
      var s = screens[i];
      var match = s.dataset.screen === screenName;
      if (attrs) for (var k in attrs) if (s.dataset[k] !== attrs[k]) match = false;
      s.classList.toggle('mirai-screen--active', match);
    }
    window.scrollTo(0, 0);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // --- Splash ---
  var startBtn = root.querySelector('[data-action="start"]');
  if (startBtn) startBtn.addEventListener('click', function () { state.inputIdx = 0; renderInput(); });

  // --- Inputs ---
  function renderInput() {
    var input = INPUTS[state.inputIdx];
    var section = root.querySelector('[data-screen="input"][data-input="' + input.key + '"]');
    section.innerHTML = ''
      + '<div class="mirai-screen-inner">'
      +   '<div class="mirai-progress-label">Step ' + (state.inputIdx + 1) + ' of 4</div>'
      +   '<div class="mirai-progress"><div class="mirai-progress-fill" style="width:' + Math.round(((state.inputIdx + 1) / 4) * 100) + '%"></div></div>'
      +   '<h2 class="mirai-input-q">' + escapeHtml(input.question) + '</h2>'
      +   '<div class="mirai-options">'
      +     input.options.map(function (o) {
              var sel = state.inputs[input.key] === o.value;
              return '<button class="mirai-option' + (sel ? ' mirai-option--selected' : '') + '" data-input-value="' + o.value + '">'
                + escapeHtml(o.label) + (o.sub ? '<span class="mirai-option-sub">' + escapeHtml(o.sub) + '</span>' : '')
                + '</button>';
            }).join('')
      +   '</div>'
      +   '<div class="mirai-step-nav">'
      +     (state.inputIdx > 0 ? '<button class="mirai-btn mirai-btn--secondary" data-input-back>Back</button>' : '<span></span>')
      +     '<button class="mirai-btn mirai-btn--primary" data-input-next' + (state.inputs[input.key] ? '' : ' disabled') + '>Next</button>'
      +   '</div>'
      + '</div>';

    section.querySelectorAll('[data-input-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('[data-input-value]').forEach(function (b) { b.classList.remove('mirai-option--selected'); });
        btn.classList.add('mirai-option--selected');
        state.inputs[input.key] = btn.dataset.inputValue;
        section.querySelector('[data-input-next]').disabled = false;
        saveState();
      });
    });

    var backBtn = section.querySelector('[data-input-back]');
    if (backBtn) backBtn.addEventListener('click', function () { state.inputIdx -= 1; renderInput(); });

    var nextBtn = section.querySelector('[data-input-next]');
    nextBtn.addEventListener('click', function () {
      if (state.inputIdx < INPUTS.length - 1) {
        state.inputIdx += 1;
        saveState();
        renderInput();
      } else {
        saveState();
        fetchRecommendations();
      }
    });

    show('input', { input: input.key });
  }

  // --- Loading + fetch ---
  function fetchRecommendations() {
    show('loading');
    fetch(API_RECOMMEND, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(state.inputs),
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        state.recommendations = data.steps;
        state.stepKeys = Object.keys(data.steps);
        state.stepIdx = 0;
        saveState();
        renderStep();
      })
      .catch(function (err) {
        var loading = root.querySelector('[data-screen="loading"]');
        loading.innerHTML = '<div class="mirai-screen-inner mirai-loading"><p>Sorry, we couldn\'t build your routine. <a href="/pages/build-my-routine" style="color:#B8956A">Try again</a>.</p><p style="font-size:12px;color:#7A716A;margin-top:8px">' + escapeHtml(err.message) + '</p></div>';
      });
  }

  // --- Steps ---
  function renderStep() {
    var key = state.stepKeys[state.stepIdx];
    var picks = state.recommendations[key] || [];
    var section = root.querySelector('[data-screen="step"]');
    var totalSteps = state.stepKeys.length;
    var selected = state.selected[key];
    var label = STEP_LABELS[key] || key;

    section.innerHTML = ''
      + '<div class="mirai-screen-inner">'
      +   '<div class="mirai-progress-label">Step ' + (state.stepIdx + 1) + ' of ' + totalSteps + '</div>'
      +   '<div class="mirai-progress"><div class="mirai-progress-fill" style="width:' + Math.round(((state.stepIdx + 1) / totalSteps) * 100) + '%"></div></div>'
      +   '<div class="mirai-step-header">'
      +     '<div class="mirai-step-eyebrow">Pick your</div>'
      +     '<h2 class="mirai-step-title">' + escapeHtml(label) + '</h2>'
      +   '</div>'
      +   '<div class="mirai-product-list">'
      +     picks.map(function (p) {
              var sel = selected && selected.handle === p.handle;
              return '<button class="mirai-product-card' + (sel ? ' mirai-product-card--selected' : '') + '" data-pick="' + escapeHtml(p.handle) + '">'
                + '<img class="mirai-product-img" src="' + escapeHtml(p.image_url || '') + '" alt="" onerror="this.style.background=\'#EDE3D2\';this.src=\'\';">'
                + '<div class="mirai-product-info">'
                +   '<div class="mirai-product-vendor">' + escapeHtml(p.vendor || '') + '</div>'
                +   '<div class="mirai-product-title">' + escapeHtml(p.title) + '</div>'
                +   '<div class="mirai-product-price">$' + (p.price_cents / 100).toFixed(2) + '</div>'
                +   (p.why ? '<div class="mirai-product-why">' + escapeHtml(p.why) + '</div>' : '')
                + '</div>'
              + '</button>';
            }).join('')
      +   '</div>'
      +   '<div class="mirai-step-nav">'
      +     '<button class="mirai-btn mirai-btn--secondary" data-step-back>Back</button>'
      +     '<button class="mirai-btn mirai-btn--primary" data-step-next' + (selected ? '' : ' disabled') + '>Next</button>'
      +   '</div>'
      + '</div>';

    section.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.pick;
        var pick = picks.find(function (p) { return p.handle === handle; });
        state.selected[key] = Object.assign({}, pick, { step: key });
        saveState();
        section.querySelectorAll('[data-pick]').forEach(function (b) { b.classList.remove('mirai-product-card--selected'); });
        btn.classList.add('mirai-product-card--selected');
        section.querySelector('[data-step-next]').disabled = false;
      });
    });

    section.querySelector('[data-step-back]').addEventListener('click', function () {
      if (state.stepIdx === 0) { state.inputIdx = INPUTS.length - 1; renderInput(); return; }
      state.stepIdx -= 1; saveState(); renderStep();
    });

    section.querySelector('[data-step-next]').addEventListener('click', function () {
      if (state.stepIdx < totalSteps - 1) { state.stepIdx += 1; saveState(); renderStep(); }
      else { renderSummary(); }
    });

    show('step');
  }

  // --- Summary ---
  function renderSummary() {
    var section = root.querySelector('[data-screen="summary"]');
    var picks = state.stepKeys.map(function (k) { return state.selected[k]; }).filter(Boolean);
    var subtotal = picks.reduce(function (s, p) { return s + p.price_cents; }, 0);
    var discounted = Math.round(subtotal * 0.85);

    section.innerHTML = ''
      + '<div class="mirai-screen-inner mirai-summary">'
      +   '<h2>Your routine is ready</h2>'
      +   '<div class="mirai-summary-list">'
      +     picks.map(function (p) {
              return '<div class="mirai-summary-row">'
                + '<img src="' + escapeHtml(p.image_url || '') + '" alt="" onerror="this.style.background=\'#EDE3D2\';this.src=\'\';">'
                + '<div><div class="mirai-summary-step">' + escapeHtml(STEP_LABELS[p.step] || p.step) + '</div><div class="mirai-summary-name">' + escapeHtml(p.title) + '</div></div>'
                + '<div class="mirai-summary-price">$' + (p.price_cents / 100).toFixed(2) + '</div>'
              + '</div>';
            }).join('')
      +   '</div>'
      +   '<div class="mirai-discount-code" data-action="copy-code">Your code: <span data-code-placeholder>(generated on save)</span></div>'
      +   '<div class="mirai-totals">'
      +     '<div class="mirai-totals-row"><span>Subtotal</span><span>$' + (subtotal / 100).toFixed(2) + '</span></div>'
      +     '<div class="mirai-totals-row"><span>Bundle discount (15%)</span><span>-$' + ((subtotal - discounted) / 100).toFixed(2) + '</span></div>'
      +     '<div class="mirai-totals-row mirai-totals-row--final"><span>Your total</span><span>$' + (discounted / 100).toFixed(2) + '</span></div>'
      +   '</div>'
      +   '<div class="mirai-cta-stack">'
      +     '<button class="mirai-btn mirai-btn--primary mirai-btn--full mirai-btn--lg" data-action="shop">Shop this routine $' + (discounted / 100).toFixed(2) + '</button>'
      +     '<button class="mirai-btn mirai-btn--secondary mirai-btn--full" data-action="save">Save to My Mirai</button>'
      +     '<button class="mirai-btn mirai-btn--text" data-action="email">Email me my routine</button>'
      +   '</div>'
      +   '<form class="mirai-email-form" data-email-form><input type="email" placeholder="you@example.com" required><button type="submit" class="mirai-btn mirai-btn--primary">Send</button></form>'
      + '</div>';

    section.querySelector('[data-action="shop"]').addEventListener('click', function () { doShop(picks); });
    section.querySelector('[data-action="save"]').addEventListener('click', function () { doSave(picks); });
    section.querySelector('[data-action="email"]').addEventListener('click', function () {
      section.querySelector('[data-email-form]').classList.toggle('mirai-open');
    });
    section.querySelector('[data-email-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      alert('Email send not wired in v1. For now, save to My Mirai or shop directly.');
    });

    show('summary');
  }

  function doShop(picks) {
    var endpoint = customerLoggedIn ? API_SAVE : API_SHOP_ANON;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inputs: state.inputs, picks: picks }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.cart_url) throw new Error(data.error || 'unknown');
        clearState();
        window.location.href = data.cart_url;
      })
      .catch(function (err) { alert('Sorry, something went wrong: ' + err.message); });
  }

  function doSave(picks) {
    if (!customerLoggedIn) {
      var ret = '/pages/build-my-routine?save_after_login=1';
      window.location.href = '/account/login?return_url=' + encodeURIComponent(ret);
      return;
    }
    fetch(API_SAVE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inputs: state.inputs, picks: picks }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'unknown');
        var el = document.querySelector('[data-code-placeholder]');
        if (el) el.textContent = data.routine.discount_code;
        alert('Saved! Your code is ' + data.routine.discount_code);
      })
      .catch(function (err) { alert('Save failed: ' + err.message); });
  }

  // --- Boot ---
  if (saveAfterLogin && state.stepKeys && state.stepIdx >= state.stepKeys.length - 1) {
    renderSummary();
    setTimeout(function () {
      var picks = state.stepKeys.map(function (k) { return state.selected[k]; }).filter(Boolean);
      doSave(picks);
    }, 500);
  } else if (state.recommendations && state.stepKeys) {
    renderStep();
  }
})();
